import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de/translation.json";
import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";
import nl from "./locales/nl/translation.json";

// Initialize i18n
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      fr: { translation: fr },
      nl: { translation: nl },
    },
    lng: "en", // Default language
    fallbackLng: "en", // Fallback language if translation not found
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    ns: ["translation"],
    defaultNS: "translation", // The default namespace if not specified
    react: {
      useSuspense: false, // Set to false when not using a backend for lazy loading
    },
    supportedLngs: ["en", "de", "nl", "fr"], // List all supported languages
    nonExplicitSupportedLngs: true,
    debug: true,
  });

export default i18n;
